import React from "react";
import { Helmet } from "react-helmet";
import { getPartnerConfig } from "utils/partner";

interface Props {
  title?: string;
  children?: React.ReactNode;
}

const DocumentHead: React.FC<Props> = ({ title, children }) => {
  const partner = getPartnerConfig();

  return (
    <Helmet>
      {title && (
        <title>
          {title} | {partner.name}
        </title>
      )}
      {children}
    </Helmet>
  );
};

export default DocumentHead;
